var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholder = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 15.535-3.515-3.516L12 8.504l3.515 3.515zm1.15 4.34a1.6 1.6 0 0 1-1.15.479 1.62 1.62 0 0 1-1.15-.48l-6.763-6.763a1.5 1.5 0 0 1-.339-.515A1.6 1.6 0 0 1 3.627 12q0-.299.121-.596.12-.298.339-.516l6.757-6.757q.242-.243.538-.364.295-.12.618-.12a1.62 1.62 0 0 1 1.156.484l6.757 6.757q.218.218.339.516.12.297.121.596 0 .297-.121.596-.121.298-.338.515zm-.823-1.002 6.546-6.546a.45.45 0 0 0 .135-.327.45.45 0 0 0-.135-.327l-6.546-6.546A.41.41 0 0 0 12 5.002a.48.48 0 0 0-.327.144l-6.565 6.565a.39.39 0 0 0-.125.308.46.46 0 0 0 .144.308l6.546 6.546q.135.135.327.135a.45.45 0 0 0 .327-.135"
  })));
};
export default SvgPlaceholder;